import { HttpClient } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import { Observable } from 'rxjs';
import { mapDto } from '@shared/operators';
import { ApiResponse } from '@shared/models';
import { IdNameDto, MaterialDto } from '@app/store/shared/models';
import { GetMaterialsValue, GetMaterialsValueDto, MaterialLookup, Materials } from '../models';

@Service()
export class HttpService {
    private readonly httpClient = inject(HttpClient);

    getMaterials(value: GetMaterialsValue): Observable<Materials> {
        const params = new GetMaterialsValueDto(value).toHttpParams();

        return this.httpClient.get<ApiResponse<MaterialDto[]>>('v1/admin/materials', { params }).pipe(mapDto((response) => new Materials(response)));
    }

    getMaterialsLookup(): Observable<MaterialLookup[]> {
        return this.httpClient
            .get<ApiResponse<IdNameDto[]>>('v1/admin/materials/lookup')
            .pipe(mapDto((response) => response.data.map((dto) => new MaterialLookup(dto))));
    }
}
